import { StatusValue } from "../../../../application/domain/proc-management";
import { route } from "../../../../application/domain/routing/named-route";
import { REG_EXP_STR_FOR_UUID } from "../../../../utils/url-utils";
import { ProcManagementContainer } from "../org-detail/proc-management";
import { ProcManagementCreateContainer } from "./create";
import {
  ProcManagementEditContainer,
  RedirectToProcManagementEditContainer,
} from "./edit";
import { ProcManagementListContainer } from "./list";
import { ProcManagementPlaceCreateContainer } from "./place-create";
import {
  ProcManagementPlaceEditContainer,
  RedirectToProcManagementPlaceEditContainer,
} from "./place-edit";
import { ProcManagementPlacesListContainer } from "./place-list";

export const ServiceProviderProcManagementRoutes = {
  ProcManagement: route({
    path: "/service-provider/orgs/:orgId/proc-management",
    link: (args: { orgId: string }) => {
      return `/service-provider/orgs/${args.orgId}/proc-management`;
    },
    component: ProcManagementContainer,
  }),
  ProcManagementProcsList: route({
    path: "/service-provider/orgs/:orgId/proc-management/procedures",
    link: (args: {
      orgId: string;
      page?: number;
      q?: string;
      statuses?: StatusValue[];
    }) => {
      const queries = [];
      if (typeof args.q === "string") {
        queries.push(`q=${args.q}`);
      }
      if (typeof args.page === "number") {
        queries.push(`page=${args.page}`);
      }
      if (args.statuses && Array.isArray(args.statuses)) {
        queries.push(`status=${args.statuses.join(",")}`);
      }
      return `/service-provider/orgs/${args.orgId}/proc-management/procedures${
        queries.length > 0 ? `?${queries.join("&")}` : ""
      }`;
    },
    component: ProcManagementListContainer,
  }),
  ProcManagementCreate: route({
    path: `/service-provider/orgs/:orgId/proc-management/procedures/new`,
    link: (args: { orgId: string }) => {
      return `/service-provider/orgs/${args.orgId}/proc-management/procedures/new`;
    },
    component: ProcManagementCreateContainer,
  }),
  ProcManagementDetail: route({
    path: `/service-provider/orgs/:orgId/proc-management/procedures/:procId(${REG_EXP_STR_FOR_UUID})`,
    link: (args: { orgId: string; procId: string }) => {
      return `/service-provider/orgs/${args.orgId}/proc-management/procedures/${args.procId}`;
    },
    component: RedirectToProcManagementEditContainer,
  }),
  ProcManagementEdit: route({
    path: `/service-provider/orgs/:orgId/proc-management/procedures/:procId(${REG_EXP_STR_FOR_UUID})/edit`,
    link: (args: { orgId: string; procId: string }) => {
      return `/service-provider/orgs/${args.orgId}/proc-management/procedures/${args.procId}/edit`;
    },
    component: ProcManagementEditContainer,
  }),
  ProcManagementPlacesList: route({
    path: "/service-provider/orgs/:orgId/proc-management/places",
    link: (args: { orgId: string; page?: number }) =>
      `/service-provider/orgs/${args.orgId}/proc-management/places${
        typeof args.page === "number" ? `?page=${args.page}` : ""
      }`,
    component: ProcManagementPlacesListContainer,
  }),
  ProcManagementPlaceCreate: route({
    path: "/service-provider/orgs/:orgId/proc-management/places/new",
    link: (args: { orgId: string }) =>
      `/service-provider/orgs/${args.orgId}/proc-management/places/new`,
    component: ProcManagementPlaceCreateContainer,
  }),
  ProcManagementPlaceDetail: route({
    path: `/service-provider/orgs/:orgId/proc-management/places/:placeId(${REG_EXP_STR_FOR_UUID})`,
    link: (args: { orgId: string; placeId: string }) =>
      `/service-provider/orgs/${args.orgId}/proc-management/places/${args.placeId}`,
    component: RedirectToProcManagementPlaceEditContainer,
  }),
  ProcManagementPlaceEdit: route({
    path: `/service-provider/orgs/:orgId/proc-management/places/:placeId(${REG_EXP_STR_FOR_UUID})/edit`,
    link: (args: { orgId: string; placeId: string }) =>
      `/service-provider/orgs/${args.orgId}/proc-management/places/${args.placeId}/edit`,
    component: ProcManagementPlaceEditContainer,
  }),
};
